export default __webpack_public_path__ + "increase-size-option.png";